export default "__VITE_ASSET__CiTGdjPy__"